import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {makeStyles} from '@material-ui/core/styles';
import {Button} from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));


export default class NotificationSnackBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    }
  }

  componentDidMount() {
    this.setState({
      open: true
    })
  }

  handleClick = () => {
    this.setState({
      open: true
    })
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (this.props.init != undefined) this.props.init();
    this.setState({
      open: false
    }, () => {
      if (this.props.clean != undefined) this.props.clean();
    })
  };

  render() {
    return (
      <Snackbar open={this.state.open}
                autoHideDuration={2000}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
      >
        <Alert onClose={this.handleClose} severity={this.props.variant}>
          {this.props.message}
        </Alert>
        {/*<Alert severity="error">This is an error message!</Alert>*/}
        {/*<Alert severity="warning">This is a warning message!</Alert>*/}
        {/*<Alert severity="info">This is an information message!</Alert>*/}
        {/*<Alert severity="success">This is a success message!</Alert>*/}
      </Snackbar>
    );
  }
}

export {NotificationSnackBar}
